import * as React from 'react';
import type { ChangeHook } from 'react-router';
import { Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import AllCollectionsPageRoot from 'bundles/enterprise-collections/pages/AllCollectionsPageRoot';
import { ProgramHomePageTypes } from 'bundles/program-home/constants/ProgramHomeConstants';
import RouteNames from 'bundles/program-home/constants/RouteNames';
import EnterprisePageWrapper from 'bundles/unified-home-common/pages/enterprise/EnterprisePageWrapper';

const CollectionDetailsPageRoot = loadOnRoute(
  () => import('bundles/enterprise-collections/pages/CollectionDetailsPageRoot')
);

const NotFound = loadOnRoute(() => import('bundles/phoenix/components/NotFound'));

const scrollToTopOnNavigate: ChangeHook = (prevState, nextState) => {
  if (nextState.location.action !== 'PUSH') {
    // history navigation
    return;
  }

  if (nextState.location.pathname !== prevState.location.pathname) {
    // always on path navigation
    window.scrollTo(0, 0);
  }
};

const routes = (
  <CourseraRoute
    onChange={scrollToTopOnNavigate}
    handle={{
      tracking: {
        data: (params) => ({
          page: { segment: 'enterprise' },
          enterprise: {
            ...(params?.programSlug ? { programSlug: params.programSlug } : {}),
          },
        }),
      },
    }}
  >
    <CourseraRoute
      name={RouteNames.PROGRAM_HOME}
      path="programs(/:programSlug)"
      component={EnterprisePageWrapper}
      handle={{
        tracking: {
          data: (_, location) => {
            const currentTab = location?.query?.currentTab as keyof typeof ProgramHomePageTypes;

            return {
              page: { type: ProgramHomePageTypes[currentTab] ?? ProgramHomePageTypes.CATALOG },
            };
          },
        },
      }}
    >
      <CourseraRoute
        name={RouteNames.COLLECTION_DETAILS}
        path="collections"
        handle={{
          tracking: {
            data: () => ({
              page: { type: ProgramHomePageTypes.RECOMMENDATIONS },
            }),
          },
        }}
      >
        <Route path=":collectionId" getComponent={CollectionDetailsPageRoot} />
        <Route path=":contextType/:contextId" getComponent={CollectionDetailsPageRoot} />
      </CourseraRoute>
      <CourseraRoute
        name={RouteNames.VIEW_ALL_COLLECTIONS}
        path="view-all-collections(/:collectionType)"
        component={AllCollectionsPageRoot}
        handle={{
          tracking: {
            data: () => ({
              page: { type: ProgramHomePageTypes.RECOMMENDATIONS },
            }),
          },
        }}
      />
    </CourseraRoute>
    <Route path="*" getComponent={NotFound} />
  </CourseraRoute>
);

export default routes;
